import { UpgradeModel } from "types";

import senecaCoreFourImage from "assets/upgrade-seneca-core-four.svg";
import senecaCoreOneImage from "assets/upgrade-seneca-core-one.svg";
import senecaCoreThreeImage from "assets/upgrade-seneca-core-three.svg";
import senecaCoreTwoImage from "assets/upgrade-seneca-core-two.svg";

import { reactorCoreAnimation } from "components/styles/animations";
import { DEFAULT_REACTOR_SPEED } from "../constants";

const SENECA_SHIPWORKS_UPGRADES: Record<string, UpgradeModel> = {
  seneca_core_one: {
    slug: "seneca_core_one",
    name: "Seneca Core I",
    description: "A standard low performance reactor core made in Vale.",
    image: senecaCoreOneImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 10,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_prime_one: {
    slug: "seneca_core_prime_one",
    name: "Seneca Core Prime I",
    description: "An enhanced low performance reactor core made in Vale.",
    image: senecaCoreOneImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 10,
    },
    grade: "advanced",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_two: {
    slug: "seneca_core_two",
    name: "Seneca Core II",
    description: "A standard medium performance reactor core made in Vale.",
    image: senecaCoreTwoImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 20,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_prime_two: {
    slug: "seneca_core_prime_two",
    name: "Seneca Core Prime II",
    description: "An enhanced medium performance reactor core made in Vale.",
    image: senecaCoreTwoImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 20,
    },
    grade: "advanced",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_three: {
    slug: "seneca_core_three",
    name: "Seneca Core III",
    description: "A standard high performance reactor core made in Vale.",
    image: senecaCoreThreeImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 30,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_prime_three: {
    slug: "seneca_core_prime_three",
    name: "Seneca Core Prime III",
    description: "An enhanced high performance reactor core made in Vale.",
    image: senecaCoreThreeImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 30,
    },
    grade: "advanced",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_four: {
    slug: "seneca_core_four",
    name: "Seneca Core IV",
    description: "A standard very high performance reactor core made in Vale.",
    image: senecaCoreFourImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 40,
    },
    grade: "basic",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
  seneca_core_prime_four: {
    slug: "seneca_core_prime_four",
    name: "Seneca Core Prime IV",
    description: "An enhanced very high performance reactor core made in Vale.",
    image: senecaCoreFourImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 40,
    },
    grade: "advanced",
    derivedStatsModifiers: {
      fasterRecharge: 0.5,
      energyMultiplier: 0.5,
    },
  },
};

export default SENECA_SHIPWORKS_UPGRADES;
